import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { CITIES } from "@/data/site";
import { Seo } from "@/components/Seo";

export default function ServiceAreas() {
  return (
    <div data-testid="service-areas-page">
      <Seo title="South Florida AC Service Areas | Central Air Depot" description="AC repair and maintenance across Miami-Dade, Broward and Palm Beach Counties. Find your city and book trusted, licensed service today." />
      <section className="bg-brand-ink text-white">
        <div className="max-w-7xl mx-auto px-4 py-20 sm:py-28">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-ice mb-3">South Florida Service Areas</p>
          <h1 className="text-4xl sm:text-5xl tracking-tighter leading-none font-black max-w-2xl">Three counties. One standard of care.</h1>
          <p className="text-base sm:text-lg text-zinc-300 mt-4 max-w-xl">
            Miami-Dade, Broward and Palm Beach — and growing city by city. Pick your city for local details.
          </p>
        </div>
      </section>
      <section className="bg-brand-subtle">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:py-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CITIES.map((c) => (
            <Link key={c.slug} to={`/areas/${c.slug}`} data-testid={`area-card-${c.slug}`}
              className="bg-white border border-zinc-200 p-8 rounded-sm hover:border-brand hover:-translate-y-1 hover:shadow-lg transition-[transform,border-color,box-shadow] duration-300 group">
              <MapPin className="w-6 h-6 text-brand mb-4" />
              <h2 className="font-heading font-bold text-2xl text-brand-ink group-hover:text-brand transition-colors duration-200">{c.name}, FL</h2>
              <p className="text-sm text-zinc-600 mt-3 leading-relaxed">{c.blurb}</p>
              <span className="text-brand text-sm font-medium mt-4 inline-block">AC services in {c.name} →</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
